import { ReactNode, useEffect } from 'react'
import { log } from '../utils/logger'
import { Navigate, useLocation } from 'react-router-dom'
import { Loader, Center } from '@mantine/core'
import { useAuth } from '@/hooks/useAuth'

interface ProtectedRouteProps {
    children: ReactNode
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth()
    const location = useLocation()

    useEffect(() => {
        // Store the intended destination when user is not authenticated
        if (!isLoading && !isAuthenticated) {
            const intendedPath = location.pathname + location.search + location.hash
            log('🔒 ProtectedRoute - Storing redirect path:', intendedPath)
            localStorage.setItem('redirectAfterAuth', intendedPath)

            // Verify it was stored
            const storedPath = localStorage.getItem('redirectAfterAuth')
            log('✅ ProtectedRoute - Verified stored path:', storedPath)
        }
    }, [isAuthenticated, isLoading, location])

    if (isLoading) {
        return (
            <Center h={200}>
                <Loader size="lg" />
            </Center>
        )
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    return <>{children}</>
} 